export const ProductUsageBar = ({ percentUtilized }: { percentUtilized: number }) => {
    const remaining = 100 - percentUtilized;
    return (
        <>
            <div className="product-usage-bar">
                <div className="utilized" style={{ width: `${percentUtilized}%` }} />
                <div className="remaining" style={{ width: `${remaining}%` }} />
            </div>
        </>
    );
};
